import React from 'react'
import { Skeleton } from '@/components/ui/skeleton'

const AlbumsViewSkeleton: React.FC = () => (
  <div className="grid grid-cols-2 gap-4 md:grid-cols-3 xl:grid-cols-4">
    {[0, 1, 2, 3, 4, 5, 6, 7].map((i) => (
      <div key={i} className="space-y-2">
        <Skeleton className="aspect-square w-full" />
        <Skeleton className="h-4 w-2/3" />
        <Skeleton className="h-3 w-1/3" />
      </div>
    ))}
  </div>
)

export default AlbumsViewSkeleton
